import fetchServer from "../helpers/api/fetchServer";

export const createSetupTemplate = async ({
  adAccountId,
  name,
  isUsedForPostBoost,
  isUsedForCampaigns,
  facebookAccountId,
  instagramAccountId,
  tikTokAccountId,
  facebookPixel,
}) => {
  const method = "POST";
  const urlAPI = "/api/setupTemplates";
  const body = {
    adAccount: adAccountId,
    name,
    isUsedForPostBoost,
    isUsedForCampaigns,
    ...(!!facebookAccountId ? { facebookAccount: facebookAccountId } : {}),
    ...(!!instagramAccountId ? { instagramAccount: instagramAccountId } : {}),
    ...(!!tikTokAccountId ? { tikTokAccount: tikTokAccountId } : {}),
    facebookPixel,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const getSetupTemplates = async () => {
  const method = "GET";
  const urlAPI = "/api/setupTemplates";
  return await fetchServer({ method, urlAPI });
};

export const getSetupTemplatesByAdAccount = async (adAccountId) => {
  const method = "GET";
  const urlAPI = `/api/setupTemplates?adAccount=${adAccountId}`;
  return await fetchServer({ method, urlAPI });
};

export const getSetupTemplate = async (id) => {
  const method = "GET";
  const urlAPI = `/api/setupTemplates/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const updateSetupTemplate = async ({
  id,
  name,
  adAccountId,
  isUsedForPostBoost,
  isUsedForCampaigns,
  facebookAccountId,
  instagramAccountId,
  tikTokAccountId,
  facebookPixel,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/setupTemplates/${id}`;
  const body = {
    name,
    adAccount: adAccountId,
    isUsedForPostBoost,
    isUsedForCampaigns,
    facebookAccount: facebookAccountId || null,
    instagramAccount: instagramAccountId || null,
    tikTokAccount: tikTokAccountId || null,
    facebookPixel,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const deleteSetupTemplate = async (id) => {
  const method = "DELETE";
  const urlAPI = `/api/setupTemplates/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const restoreSetupTemplate = async (id) => {
  const method = "POST";
  const urlAPI = `/api/setupTemplates/${id}/restore`;
  return await fetchServer({ method, urlAPI });
};

export const deleteSetupTemplates = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/setupTemplates/bulk-delete";
  const body = { ids };
  return await fetchServer({ method, urlAPI, body });
};

export const restoreSetupTemplates = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/setupTemplates/bulk-restore";
  const body = { ids };
  return await fetchServer({ method, urlAPI, body });
};
